import { Injectable } from '@angular/core';
import { SidebarState } from '../constants/navigation.constants';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private _sidebarState!: SidebarState;
  private _fontSize!: number;

  constructor() {
    this.sidebarState = window.localStorage.getItem('sidebarState') ?? SidebarState.COLLAPSE;
    this.fontSize = parseInt(window.localStorage.getItem('baseFontSize') ?? '14', 10) ;
   }

  /**
   * On app load, check Local storage for light or dark mode preference.
   * If none is found, default to the system setting.
   * Sets the class on the HTML element.
   * @param mode Either 'toggle' or 'initial' - defaults to 'toggle'
   */
  setDarkOrLightTheme(mode: 'toggle' | 'initial' = 'toggle') {
    const html = document.querySelector('html');
    let preference = 'light';
    if (mode === 'initial') {
      preference = window.localStorage.getItem('preferredTheme') ?? this.importThemePreferenceFromSystem();
    } else {
      preference = html?.classList.contains('qh-dark') ? 'light' : 'dark';
    }
    window.localStorage.setItem('preferredTheme', preference); 
    const themeClass = `qh-${preference}`;
    html?.classList.remove('qh-dark', 'qh-light', 'init-dark');
    html?.classList.add(themeClass);
  }
  
  /**
   * Check the system preference for light or dark mode.
   */
  importThemePreferenceFromSystem() {
    const systemPrefersLightTheme = window.matchMedia('(prefers-color-scheme: light)');
    const preferenceToStore = systemPrefersLightTheme.matches ? 'light' : 'dark';
    return preferenceToStore;
  }

  /**
   * @returns The current mode as a string based on the CSS class set on the html element.
   */
  currentThemeMode() {
    const html = document.querySelector('html');
    return html?.classList.contains('qh-dark') ? 'dark': 'light';
  }

  get sidebarState(): SidebarState {
    return this._sidebarState;
  }

  set sidebarState(state: string) {
    if (Object.values(SidebarState).includes(state as SidebarState)) {
      this._sidebarState = state as SidebarState;
      window.localStorage.setItem('sidebarState', this.sidebarState);
    }
  }

  get fontSize(): number {
    return this._fontSize;
  }

  set fontSize(size: number) {
    this._fontSize = size;
    window.localStorage.setItem('baseFontSize', this.fontSize.toString());
    const html = document.querySelector('html');
    if (html) html.style.fontSize = this.fontSize + 'px';
  }

}
